<template>
  <div class="modal fade" id="infoCodice" tabindex="-1" aria-labelledby="infoCodice" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modalInfo">
      <div class="modal-content">
        <div class="modal-header">
          <img class="aereoPopup" src="https://www.rimborsoalvolo.it/cresources/outform/images/aereoPopup.svg">
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body codiceBlock">
          <h2>Cos'è un Codice Priorità.</h2>
          <p>Rimborso al Volo ha creato <b>una rete di Partner</b> attivi nel comparto dei servizi e delle forniture dedicati ai viaggiatori. Tramite uno speciale Bollino, offriamo la possibilità ai possessori di <b>ottenere gratuitamente dei vantaggi</b> legati alla gestione prioritaria delle pratiche. Se hai ricevuto un bollino, inserisci il codice nella casella<b>"Hai un codice priorità?"</b>.
          </p>
          <p class="boldTxt"><span><img src="https://www.rimborsoalvolo.it/cresources/outform/images/infoCodice.png"></span> IL BOLLINO VIENE FORNITO UNICAMENTE DAI NOSTRI PARTNER AUTORIZZATI <u>E NON DA RIMBORSO AL VOLO</u>.</p>
        </div>
        <div class="bollino row g-0 ">
          <div class="col-lg-6 col-md-4">
            <img src="https://www.rimborsoalvolo.it/cresources/outform/images/bollinoRavFronte.svg">
          </div>
          <div class="col-lg-6 col-md-8">
            <div class="row">
              <div class="col-6"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/bollinoRavRetro.svg"></div>
              <div class="col-6 bollinoRavRetro">
                <p> Se hai ricevuto il nostro
                  Bollino, copia dal retro
                  il codice e inseriscilo
                  in questo campo. </p>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PopupCodicePriorita"
}
</script>

<style scoped>

</style>